/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgListItemLayout = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M2 21h8v-6H2zm2-4h4v2H4zm8-14h6v2h-6zm0 12h6v2h-6zm0-8h10v2H12zm8-4h2v2h-2zm0 12h2v2h-2zM2 9h8V3H2zm2-4h4v2H4zm8 14h10v2H12z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgListItemLayout as ListItemLayout };
